import React from "react";
import styles from "./scss/nointernet.module.scss";
import nodata from "../../../styles/images/nolarge.svg";
export default function ChatNoInternet() {
  return (
    <>
      <div className={styles.ifnoInternet}>
        <div className={styles.networkStatus}>
          <div className={styles.darkHeadsec}>
            <div className={styles.IconSecConInner}>
              <img src={nodata} alt=""/>
            </div>
            <div className={styles.rightTxtCon}>
              <span className={styles.noInterTxt}>Hmmm, you are not Connected</span>
              <span  className={styles.noInterTxtChild}>Go online to load more messages.</span>
            </div>
          </div>
        </div>
        <div className={styles.networkError}>
          <img src={nodata} alt=""/>
          <span> Worktual is trying to connect…</span>
        </div>
      </div>
    </>
  );
};

